import { render } from "./wallet.vue?vue&type=template&id=1d9e5090&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"

import "./wallet.vue?vue&type=style&index=0&id=1d9e5090&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9e5090"]])

export default __exports__